import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { useEffect, useState } from 'react';

import SearchPage from '@/snippets/search/SearchPage';

export const getStaticProps = getStatic.props.settings;

function Search() {
  // loaded state necessary to avoid hydration errors due to ssr and yotpo replacing the html
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div className="py-10">{loaded && <SearchPage />}</div>
  );
}

export default Search;
